<script setup>
import {useTheme} from "@/store/useTheme";
import {computed} from "vue";

const themeSetter = useTheme()

const theme = computed(() => {
  return localStorage.getItem('theme') ? localStorage.getItem('theme') : themeSetter.activeTheme
})
</script>
<template>
  <div class="app" :class="theme">
    <router-view/>
  </div>
</template>

<style lang="scss" scoped>
.app {
  height: 100vh;
}
</style>
